import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';

import { AppConfigProvider } from './context/AppContextProvider';

import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppConfigProvider>
      <App />
    </AppConfigProvider>
  </Provider>
);
